const getters = {
    token: state => state.app.token,
    lang: state => state.app.lang,
    model: state => state.app.model,
    platform: state => state.app.platform,
    version: state => state.app.version,
}
export default getters